import { render, staticRenderFns } from "./SvgIcon.vue?vue&type=template&id=09e7b840&scoped=true"
import script from "./index.ts?vue&type=script&lang=ts&external"
export * from "./index.ts?vue&type=script&lang=ts&external"
import style0 from "./SvgIcon.vue?vue&type=style&index=0&id=09e7b840&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e7b840",
  null
  
)

export default component.exports